export enum ErrorTypes {
    APP = 'APP',
    TESTANIA = 'TESTANIA',
    PAYMENTS = 'PAYMENTS',
    APP_AXIOS = 'APP_AXIOS',
    ANALYTIC = 'ANALYTIC',
}
